import { antecedentesApi } from "../view/antecedentes.service";

export const deleteAntecedente = antecedentesApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteAntecedente: builder.mutation({
      query: (id) => ({
        url: `/v1/api/antecedenteacademico/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Antecedentes", id: "LIST" }],
    }),
  }),
});

export const { useDeleteAntecedenteMutation } = deleteAntecedente;
